// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-dialog-footer[data-v-c9f227e8]{position:relative;padding:0;display:flex;align-items:center;justify-content:flex-end}.ui-dialog-footer .ui-button[data-v-c9f227e8]{margin:0}.ui-dialog-footer .ui-button+.ui-button[data-v-c9f227e8]{margin-left:8px}\n", ""]);
// Exports
module.exports = exports;
